import { render, staticRenderFns } from "./FibonacciSettings.vue?vue&type=template&id=2bc78b76"
import script from "./FibonacciSettings.vue?vue&type=script&lang=js"
export * from "./FibonacciSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports